import { render, staticRenderFns } from "./IconReset.vue?vue&type=template&id=0254fa50&"
var script = {}
import style0 from "./IconReset.vue?vue&type=style&index=0&id=0254fa50&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports